<template>
  <div class="body">
    <div class="body-navs">
      <div v-for="item in menus"
           :key="item.label"
           class="body-navs-nav"
           :class="{'body-navs-nav': true, 'body-navs-navOn': item.path == path}"
           @click="onRouter(item.path)">
        <div class="body-navs-nav-label">{{item.label}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from "@/store/menu";
export default {
  name: "AppNav",
  components: {},
  data () {
    return {
      path: "",
      menus: menuList,
    };
  },
  // watch: {
  //     $route: {
  //         handler: function(route) {
  //             console.log(route.path)
  //             this.path = route.path;
  //         },
  //     }
  // },

  mounted () {
    // this.$nextTick(() => {
    //   console.log(this.$route.path)
    // })
  },
  methods: {
    onRouter (path) {
      this.show = false;
      this.path = path;
      this.$router.push({
        path: `${path}`,
      });
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
